import { defineStore } from 'pinia';
import { themeOptions } from '@/Models';
import WebStorage, { storageTypes } from '@/Utils/WebStorage';

const defaultMode = themeOptions[themeOptions.system].name.toLowerCase();

const webThemeStorage = new WebStorage('store.webTheme', storageTypes.localStorage);
const webThemeStorageData = webThemeStorage.get();
const webThemeStorageMode = webThemeStorageData?.mode || defaultMode;

export const useWebThemeStore = defineStore({
    id: 'webTheme',
    state: () => ({
        mode: webThemeStorageMode,
        theme: document.documentElement.getAttribute('data-theme'),
    }),
    actions: {
        setCurrentTheme(theme, mode) {
            this.theme = theme;
            this.mode = mode;
            document.documentElement.setAttribute('data-theme', theme);
            webThemeStorage.set({ theme, mode });
        },
    },
    getters: {
        isInDarkMode() {
            return this.theme === themeOptions[themeOptions.dark].name.toLowerCase();
        },
    },
});